<template>
  <div class="recommend-wrapper flex-column-center">
    <div class="flex-between recommend-header">
      <span class="recommend-title">推荐职位</span>
      <div class="more" @click="toJobs">更多职位</div>
<!--      <p class="flex-start more" @click="toJobs">-->
<!--        <span>更多职位</span>-->
<!--        <span class="iconfont iconchevron-right"/>-->
<!--      </p>-->
    </div>
    <job-list :list-data="recommendList" isShowRecommendLanguage :job-list-ad-bean="jobListAdBean" :options="{isRecommendText: true}"/>
    <div class="more-btn flex-center" @click="toJobs">查看更多职位</div>
  </div>
</template>

<script>
	import jobList from '../job-components/job-list'
	import { envMixin } from '../../assets/js/mixin/global'
  import { mapState } from 'vuex'

	export default {
		name: 'cv-recommend-jobs',
		mixins: [ envMixin ],
		data () {
			return {
				recommendList: [],
        jobListAdBean: null, // 职位列表广告
			}
		},
		mounted () {
			this.getListData()
		},
		computed: {
			...mapState('cv', [ 'onlineCvData' ])
    },
		watch: {},
		components: {
			jobList
		},
		methods: {
			toJobs () {
				if (this.iosOrAndroid) {
					window.location.href = '/jobs/'
				} else {
          this.$fn.switch(`/pages/jobs/index`, () => {
            this.$router.push('/jobs/recommend')
          })
				}
			},
			async getListData () {
				// let payload = { jd_flag: 0, from: 0, size: 6, resume_flag: 1 }
				let payload = {
          size: 10,
		      page: 1,
          resume_token: null
        }
				if (this.onlineCvData.token) {
					payload.resume_token = this.onlineCvData.token
        } else if (this.onlineCvData.resume) {
					payload.resume_token = this.onlineCvData.resume.token
        }
				let res = await this.$api.recommend.cvsToJob(payload)
				if (res.code === 1000) {
					this.recommendList = res.data.jobs
				}
        let adResp = await this.$api.jobs.getBannerImg({position: 28}); //18
        if (adResp.code === 1000) {
          if(adResp.data.length){
            let dataSource = adResp.data[0];
            dataSource['page_type'] = 'cvs';
            this.jobListAdBean = dataSource;
          }
        }
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .recommend-wrapper {
    width: 100vw;
    padding: 28px 0 0;
    border-top: 12px solid #f9f9f9;
    /*background-color: #f9f9f9;*/
    .recommend-header {
      height: 20px;
      width: 100%;
      padding: 0 24px;
      margin-bottom: 6px;
      .more {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 76px;
        height: 24px;
        border-radius: 12px;
        border: 1px solid #ececec;
        font-size: 13px;
        color: #606060;
      }
      .recommend-title {
        color: $color-title;
        font-size: 18px;
        font-weight: 500;
        //line-height: 16px;
        //&::before {
        //  content: '';
        //  display: inline-block;
        //  width: 2px;
        //  height: 12px;
        //  background-color: $color-theme;
        //  border-radius: 1px;
        //  margin-right: 8px;
        //}
      }
      //.more {
      //  height: 100%;
      //  color: #9c9c9c;
      //  font-size: $font-size-medium;
      //  .iconfont {
      //    color: #9c9c9c;
      //    font-weight: bold;
      //    margin-left: 5px;
      //  }
      //}
    }
    /deep/ .job-content {
      border-bottom: 6px solid #f9f9f9;
      &:last-child {
        border-bottom: none;
      }
    }
    /deep/ .recommend-item {
      padding: 20px 24px;
      border-bottom: 6px solid #f9f9f9;
      &:last-child {
        border: none;
      }
    }
    .more-btn {
      width: 280px;
      height: 42px;
      border-radius: 22px;
      background-color: #F9F9F9;
      color: $color-dark-gray;
      letter-spacing: 1px;
      margin-top: 8px;
      margin-bottom: 28px;
    }
  }
</style>
